import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "romName"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.romList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.code,
      class: "romItem",
      onClick: $event => $setup.goToGame(item.code)
    }, [_createElementVNode("img", {
      src: `${$setup.config.serverUrl}/romStatic/img/${item.code}.jpg`,
      alt: ""
    }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1)], 8, _hoisted_2);
  }), 128))]);
}